<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="productSpecificationId" :primary-key="form.productSpecificationId"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Específicações"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.productSpecificationId" hidden/>

      <b-col cols="12" class="mb-2">

        <t-input v-model="form.typeRelation" label="Tipo de Conversão" hide-label :options="SpecificationType.list"
                 radio
                 required/>

        <b-row>

          <b-col xl="9">

            <b-row>


              <b-col cols="6" v-if="form.typeRelation === SpecificationType.type.CUSTOMER">
                <t-input-person customer
                                v-model="form.customerId" required/>
              </b-col>


              <t-input cols="6" v-if="form.typeRelation === SpecificationType.type.GROUP_CUSTOMER"
                       v-model="form.customerGroupId"
                       label="Grupo de Cliente"
                       :options="groupCustomerOptions" required select/>


              <b-col cols="6">

                <t-input-code-label compound v-model="form.compoundId" :add-error="error.compoundId" required/>

              </b-col>


            </b-row>

            <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          </b-col>

          <b-col xl="3" class="button-form-inline">

            <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command)" no-icon submit/>

            <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
              {{ t('go-back') }}
            </b-link>

          </b-col>


        </b-row>


      </b-col>


    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import SpecificationType from "@/model/types/modules/product/SpecificationType";
import http from "@/services/config/http-common";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ProductSpecification',
  data() {
    return {
      SpecificationType,
      path: "product/item-specification", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "productId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "productSpecificationId", keyDelete: "productSpecificationId"},
        {key: "typeRelationDescription", label: "Descrição", cols: "5"},
        {key: "typeRelationName", label: "Tipo", cols: "2"},
        {key: "compound", label: "Composto", cols: "3"},
        {key: "note", label: "Obs.", cols: "2"},
      ],
      form: {
        productId: this.foreignKey,
        productSpecificationId: 0,
        typeRelation: 1,
        customerId: 0,
        customerGroupId: 0,
        compoundId: 0,
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        customerId: "",
        customerGroupId: "",
        compoundId: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
        "typeRelation",
      ],
      //--------------------------------------------------------------------------------------
      groupCustomerOptions: [],
      compoundOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.form.typeRelation = 1


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.groupCustomerOptions = response.groupCustomerOptions
      }).catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.productSpecificationId)

    },

    mountedList() {


      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
